<template>
  <div :class="['info-panel']" :style="infoPanelImage">
    <div class="info-panel--inner">
      <h2 class="mb-l pointer" @click="infoTitleClickHandler">
        <img
          v-if="title_logo"
          :src="
            `https://www.mis-implants.com/img/product-logos/${title_logo.substring(
              1
            )}.svg`
          "
          :alt="title"
          :title="title"
        />
        <span v-else v-text="title"></span>
      </h2>
      <h3 v-if="sub_title" v-text="sub_title"></h3>
      <div class="btn-group pt-l text-left">
        <abtn
          class="float-left mr-m"
          :class="btnClasses"
          v-for="button in children"
          :key="button.title"
          v-bind="button"
          mini
        >
          <span v-text="button.title"></span>
        </abtn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    sub_title: {
      type: String,
      default: null
    },
    content: String,
    summary: String,
    image: {
      type: String,
      default: null
    },
    mobile_image: {
      type: String,
      default: null
    },
    children: {
      type: Array,
      default: null
    },
    align: {
      type: String,
      default: "left"
    },
    title_logo: String
  },
  computed: {
    ...mapState(["dimensions"]),
    btnClasses() {
      return { "mr-s": true };
    },
    infoPanelImage() {
      let image =
        this.dimensions.width < 600 && this.mobile_image
          ? this.mobile_image
          : this.image;
      // console.log("IMAGE > ", image, " :: ", this.image);
      return image ? `background-image:url(${this.$imageFolder}/${image})` : "";
    }
  },
  methods: {
    infoTitleClickHandler() {
      // TEMP >> getting URL from first child (*BUTTON)
      let child = this.children[0];
      if (child) {
        let url = child.url;
        if (url) {
          this.$router.push(url);
        }
      }
    }
  }
};
</script>
<style lang="stylus">
.info-panel
  overflow hidden
  position relative
  height 60vmin
  padding 0 7%
  background-color transparent
  background-repeat no-repeat
  &:nth-child(odd)
    background-color gray_1
  &:nth-child(even)
    background-color #fff
  // +landscape()
  //   background-size auto 80%
  // +above(1200px)
  //   background-size auto 90%
  // +portrait()
  //   background-size auto 60%
  +below(767px)
    h3
      font-size 13px
  // h3
  //   max-width 80%
  h2
    img
      height 46px
      max-width 100%
      +above(26em)
        height 60px
      // +above(52em)
      //   height 115px
  _flex(row,wrap,center,flex-end)
  background-position 10% bottom
  background-size auto 100%
  +below(415px)
    background-size auto 75%

  /.grid &
  &:nth-child(odd)
    _flex(row,wrap,center,flex-start)
    background-position 90% bottom

  /.grid &
    padding 4%
    background-color gray_1
    _flex(row,wrap,flex-start,flex-start)
    +below(600px)
      height 70vw
      flex auto
      background-size  auto 70% !important
.info-panel--inner
  max-width 60%
  +desktop()
    max-width 40%
  /.grid &
    max-width 100%
    +below(600px)
      padding 20px 20px 20px 20px !important

.info-panel--inner
  h2
    margin 0px
</style>
